export enum NonConformanceReportPriority {
	High = 10,
	Medium = 20,
	Low = 30,
}